const RouterHandlers = {
  methods: {
    myHouseKeeperClickHandler() {
      this.$router.push(process.env.VUE_APP_SERVICE_PAGE_PATH);
    },
    officialWebsite() {
      this.$router.push(process.env.VUE_APP_OFFICIAL_WEBSITE_PATH);
    },
  },
};

export default RouterHandlers;
